import { BehaviorSubject, concat, delay, Observable, of, skip, switchMap } from "rxjs";
import { FormField } from "../form/form-field";
import { TableHeader } from "./table-header";
import { TABLE_TEMPLATE } from "./table-template";

export class TableField<VALUE = unknown, EXTRAS = Record<string, unknown>> {
  public template: TABLE_TEMPLATE;
  public value: BehaviorSubject<VALUE>;
  public tooltip: string | null;

  public hidden: boolean;
  public required: boolean;
  public postable: boolean;
  public name: string;

  public formfield_name: string | null;
  public loading: BehaviorSubject<boolean>;
  public formfield: BehaviorSubject<FormField | null>;

  public header: TableHeader;

  public extras: EXTRAS | null;

  public valueChanged: Observable<boolean>;

  public constructor(
    header: TableHeader,
    name: string,
    template: TABLE_TEMPLATE,
    value: VALUE,
    tooltip: string | null = null,
    extras: EXTRAS | null = null,
    formfield_name: string | null = null,
  ) {
    this.header = header;
    this.name = name;
    this.template = template;
    this.value = new BehaviorSubject(value);
    this.valueChanged = this.value.pipe(
      skip(1), // ignore initial value
      switchMap(() =>
        concat(
          of(true),
          of(false).pipe(delay(1000)), // 1000ms delay
        ),
      ),
    );
    this.tooltip = tooltip;

    this.formfield_name = formfield_name;
    this.loading = new BehaviorSubject<boolean>(false);
    this.formfield = new BehaviorSubject<FormField | null>(null);

    this.hidden = false;
    this.required = false;
    this.postable = true;

    this.extras = extras;
  }
}
